const calculateDiscount = (price: number, discountedPrice?: number) => {
  if (discountedPrice && discountedPrice !== price) {
    const discount = Math.round(((price - discountedPrice) / price) * 100);
    return discount < -100 ? 0 : discount;
  }
  return 0;
};

export default calculateDiscount;
